import { useCallback } from "react";
import { UrlForwardsApi, useAPIAction } from "melco-shared-logic";
import { AddNewForwardFormValueType } from "../../components/urlforward/form/AddNewForwardForm";

export const useAddNewForward = () => {
  const [AddNewForward] = useAPIAction(
    UrlForwardsApi,
    async (api, NewForwardDetails: AddNewForwardFormValueType) => {
      const data = await api.urlForwardsCreate({
        controlcenterMelcoControlCenterModelsForwardLinkRequest: {
          key: NewForwardDetails.key,
          target_url: NewForwardDetails.target,
        },
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "url_forward.actions.add_new",
    }
  );

  return useCallback(
    async (NewForwardDetails: AddNewForwardFormValueType) => {
      try {
        await AddNewForward(NewForwardDetails);
      } catch (e) {
        return { success: false };
      }

      return { success: true };
    },
    [AddNewForward]
  );
};
